module.exports = __webpack_public_path__ + "static/media/logo-santoamaromaranhao.4112ea65.png";